import {isAnyOf} from '@reduxjs/toolkit'

import {FamilyUser} from '@web/core/constants'
import {decodeHtmlEntities as decode} from '@web/helpers/htmlEntities'
import makeSlice from '@web/slices/payNext/sliceMaker'

import {getPaymentMethodExists, initOrderSheetByAPI, initResult} from '../../actions/familyPay'
import {getFamilyPayUser, initFamilyPayUser} from '../../actions/familyPayUser'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                state.familyPay.role = FamilyUser.PAYER
                state.familyPay.payerPaymentInfo = {
                    memberName: payload.data.familyPayPayMember?.payMemberName ?? '',
                    memberImageUrl: payload.data.familyPayPayMember?.imageUrl ?? '',
                    memberMemo: decode(payload.data.familyPayPayMember?.familyPayRequestMemo ?? ''),
                    memberPreApprovalPaymentAllowed: payload.data.familyPayPayMember?.preApprovalPayment ?? false,
                    resultType: null,
                }

                payload.data.familyPayPayMember?.preApprovalPaymentAvailableAmountPerOrder &&
                    (state.familyPay.preApprovalPaymentLimitPerTransaction =
                        payload.data.familyPayPayMember.preApprovalPaymentAvailableAmountPerOrder)
            })
            .addCase(initResult.fulfilled, (state, {payload}) => {
                state.familyPay.role = FamilyUser.PAYER
                state.familyPay.payerPaymentInfo = {
                    memberName: payload.orderUserName,
                    memberImageUrl: '',
                    memberMemo: '',
                    resultType: payload.resultType,
                }
            })
            .addCase(getPaymentMethodExists.fulfilled, (state, {payload}) => {
                if (state.familyPay.payerPaymentInfo) {
                    state.familyPay.payerPaymentInfo = {
                        ...state.familyPay.payerPaymentInfo,
                        preApprovalPaymentMethodExists: payload,
                    }
                }
            })
            .addMatcher(isAnyOf(initFamilyPayUser.fulfilled, getFamilyPayUser.fulfilled), (state, {payload}) => {
                state.familyPay.userStatus = payload.subscribeType
            })
    },
})

export default slice.reducer
